import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import { GetExternalAirlinesErrorResponse, GetExternalAirlinesSuccessResponse } from './getExternalAirlines.types'

export const getExternalAirlinesApi = async (): Promise<GetExternalAirlinesSuccessResponse> => {
  const response = await configureRequest({
    url: urls.flights.airlines,
    method: 'GET',
    data: {},
    headers: {
      'X-User-Role': UserRole.traveler
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetExternalAirlinesSuccessResponse
  } else {
    throw response as GetExternalAirlinesErrorResponse
  }
}

export default getExternalAirlinesApi
